if($('.videoSlideModuleSingleVideo').length==1){
 /* var videoSlidePropsA = {
    pagination: {
      el: '.video-slide-module-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.right-arrow-video1',
      prevEl: '.left-arrow-video1',
    },
    lazy: false,
    slidesPerView: 1.5,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      1200: {
        slidesPerView: 1.3,
        spaceBetween: 20
      },
      1000: {
        slidesPerView: 1.25,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 1.2,
        spaceBetween: 20
      },
      800: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 16
      }
    }
  }
  var videoSlideMethodsA = {
    resizeHandler: true,
    a11ySwiper: true
  }*/

  /*var videoSlideA = hp.swiperInstance('.video-slide-swipe-SingleVideo', videoSlidePropsA, videoSlideMethodsA);*/
  hp.swipers = hp.swipers || {};
  var video_slide_swipe_SingleVideo = 
  {
    initialized: false
  };

  video_slide_swipe_SingleVideo.init = function(){
    $(".video-slide-swipe-SingleVideo .swiper-slide-A>div>a").click(function(event){
      event.stopPropagation();
      var $thisContainer = $(this).parents('.card-module-container'),
          left = $(this).offset().left,
          compare = $thisContainer.offset().left + $thisContainer.width()-50;
          
      if(left > compare){return}
      
      var videoId = $(this).next().attr('id'),
          iframeId;
      $('.video-iframe[id='+videoId+']').each(function(i,x){
        iframeId = videoId+'_'+i;
        $(x).attr('id',iframeId).show().prev().css('display','none').parent().addClass('fade-to-black');
        initializePlayerSingleVideo(videoId,iframeId);
      })
    });
    /*videoSlideA.on('slideChange', function () {
      stopOtherVids()
    });*/
  }//END init

  hp.swipers.video_slide_swipe_SingleVideo = video_slide_swipe_SingleVideo;

  function onPlayerReady(event){
    //console.log('onPlayerReady',event.target)
    //event.target.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
  }
  function onPlayerStateChange(event){
    //console.log('onPlayerStateChange',event.target.a.id)
    event.data === 1 && stopOtherVids(event.target.a.id);
  }
  function initializePlayerSingleVideo(videoId,iframeId){
    if(window.YT.loaded){
      // console.log('YT loaded',iframeId)
      hp.videoRay[iframeId] = new YT.Player(iframeId, {
        videoId: videoId,
        playerVars: { 'autoplay': 1, 'rel': 0, showinfo: 0 },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });
    }else{
      // console.log('YT NOT loaded');
      setTimeout(function(){
        initializePlayerSingleVideo(videoId,iframeId)
      },100);
    }
    //console.log('initializePlayer - videoRay[videoId]2',videoId,videoRay[videoId])
  }

}
